import { render, staticRenderFns } from "./MusicSorter.vue?vue&type=template&id=35081730&scoped=true"
import script from "./MusicSorter.vue?vue&type=script&lang=js"
export * from "./MusicSorter.vue?vue&type=script&lang=js"
import style0 from "./MusicSorter.vue?vue&type=style&index=0&id=35081730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35081730",
  null
  
)

export default component.exports